"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
var getLocale = function (propLang, userLang) {
    var lang = (propLang === 'userLang' ? userLang : propLang).toLowerCase();
    return constants_1.LOCALES[lang] || constants_1.LOCALES.en;
};
var getParamsBasedOnButtonType = function (compProps) {
    return {
        buy: {
            cmdType: '_xclick',
            buildNotation: 'Wix_BuyNow_WPS_IL',
            itemName: compProps.itemName,
            itemNumber: compProps.itemID,
            submitImageAriaLabel: constants_1.BUY_BUTTON_LABEL,
        },
        donate: {
            cmdType: '_donations',
            buildNotation: 'Wix_Donate_WPS_IL',
            itemName: compProps.organizationName,
            itemNumber: compProps.organizationID,
            submitImageAriaLabel: constants_1.DONATE_BUTTON_LABEL,
        },
    }[compProps.buttonType];
};
var getAmount = function (amount) {
    if (amount && Number(amount) > 0) {
        return amount;
    }
    return '';
};
var getSubmitImgSrc = function (locale, compProps) {
    var buttonType = compProps.buttonType === 'buy' ? 'buynow' : 'donate';
    var showCreditCards = compProps.showCreditCards && !compProps.smallButton ? 'CC' : '';
    var buttonSize = compProps.smallButton ? '_SM' : '_LG';
    var localeString = compProps.showCreditCards && !compProps.smallButton
        ? locale.image + locale.cc
        : locale.image;
    return "https://www.paypalobjects.com/" + localeString + "/i/btn/btn_" + buttonType + showCreditCards + buttonSize + ".gif";
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'language'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, language = _a.language;
    var locale = getLocale(compProps.language, language);
    var _b = getParamsBasedOnButtonType(compProps), cmdType = _b.cmdType, buildNotation = _b.buildNotation, itemName = _b.itemName, itemNumber = _b.itemNumber, submitImageAriaLabel = _b.submitImageAriaLabel;
    return {
        formTarget: compProps.target,
        cmdType: cmdType,
        itemName: itemName,
        itemNumber: itemNumber,
        buildNotation: buildNotation,
        business: compData.merchantID,
        currencyCode: compProps.currencyCode,
        amount: getAmount(compProps.amount),
        trackingPixelImgSrc: "https://www.paypalobjects.com/" + locale.pixel + "/i/scr/pixel.gif",
        submitImageSrc: getSubmitImgSrc(locale, compProps),
        submitImageAriaLabel: submitImageAriaLabel,
    };
});
//# sourceMappingURL=PayPalButton.js.map